import { render, staticRenderFns } from "./StockLeaveDialog.vue?vue&type=template&id=54cf4bd7"
import script from "./StockLeaveDialog.vue?vue&type=script&lang=js"
export * from "./StockLeaveDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports